function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_93",
  "data-name": "Group 93"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_45",
  "data-name": "Path 45",
  d: "M8184.512,8183v-3.186h33.357l.284.317V8183Z",
  transform: "translate(-8149.829 -8179.816)",
  fill: "#464545"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_46",
  "data-name": "Path 46",
  d: "M8198.91,8185.562v-2.944h33.618a7.076,7.076,0,0,1,.048,1.414c.012.5,0,1,0,1.53Z",
  transform: "translate(-8130.772 -8176.109)",
  fill: "#464545"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_47",
  "data-name": "Path 47",
  d: "M8203.489,8185.639h-33.372v-2.891c1-.17,29-.243,33.372-.076Z",
  transform: "translate(-8168.872 -8176.167)",
  fill: "#464545"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_48",
  "data-name": "Path 48",
  d: "M8179.781,8208.138h-2.562v-10.119l.314-.313c1.5,0,3.01.007,4.52,0a6.3,6.3,0,0,1,1.692.4,2.614,2.614,0,0,1,1.8,2c.18,2.26-.07,3.021-1.807,4.171l2.469,3.829h-2.876l-2.223-3.64h-1.323Zm-.018-5.786c.636,0,1.18-.032,1.718.006a1.8,1.8,0,0,0,1.475-.549v-1.517l-.773-.462h-2.42Z",
  transform: "translate(-8159.485 -8156.151)",
  fill: "#464545"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_49",
  "data-name": "Path 49",
  d: "M8184.617,8197.711h2.528v3.976l3.487-3.972h3.01a5.214,5.214,0,0,1-.5.8c-1.135,1.24-2.286,2.466-3.456,3.718l4.234,5.721c-.08.09-.105.142-.129.142-.924,0-1.847,0-2.916,0l-3.121-4.2-.653.706v3.512h-2.487Z",
  transform: "translate(-8149.683 -8156.134)",
  fill: "#464545"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_50",
  "data-name": "Path 50",
  d: "M8210.947,8206.007v2.1h-7.127v-10.393h7.107v2.024c-1.476.095-3,0-4.566.052v2.052h4.115v2.1h-4.129v2.065Z",
  transform: "translate(-8124.268 -8156.13)",
  fill: "#464545"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_51",
  "data-name": "Path 51",
  d: "M8176.209,8205.812h-3.478l-.629,2.3h-2.516c.078-.276.139-.506.21-.729q1.077-3.261,2.155-6.524.455-1.374.934-2.742a2.014,2.014,0,0,1,.262-.4h2.74c.789,1.6,1.208,3.425,1.876,5.155.66,1.7,1.17,3.45,1.83,5.225-.379.012-.791.026-1.2.032-.385.006-.771,0-1.208,0C8176.5,8207.557,8176.791,8206.563,8176.209,8205.812Zm-.57-2.11c-.141-.456-.263-.827-.373-1.2-.18-.617-.342-1.239-.538-1.853-.031-.1-.192-.16-.32-.257l-1.1,3.31Z",
  transform: "translate(-8169.586 -8156.124)",
  fill: "#464545"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_52",
  "data-name": "Path 52",
  d: "M8201.314,8204.932l2.31-7.221h2.541c-.247,1.238-.767,2.343-1.111,3.5s-.795,2.3-1.234,3.439-.792,2.3-1.185,3.465h-2.68c-1.258-3.427-2.432-6.88-3.705-10.39h2.691C8199.648,8200.094,8200.664,8202.433,8201.314,8204.932Z",
  transform: "translate(-8134.297 -8156.132)",
  fill: "#464545"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_53",
  "data-name": "Path 53",
  d: "M8212.939,8199.759h-3.021v-2.032h8.752v2h-3.177v8.364c-.44.013-.849.027-1.259.033s-.84,0-1.295,0Z",
  transform: "translate(-8116.208 -8156.118)",
  fill: "#464545"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_54",
  "data-name": "Path 54",
  d: "M8194.4,8208.146h-2.478v-10.4c.78-.105,1.613.01,2.478-.059Z",
  transform: "translate(-8140.026 -8156.158)",
  fill: "#464545"
}));

var SvgArkivetLogo = function SvgArkivetLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_7MyVuJ",
    "data-name": "7MyVuJ",
    width: 102.462,
    height: 52.01,
    viewBox: "0 0 102.462 52.01",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArkivetLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arkivet-logo.413f097c.svg";
export { ForwardRef as ReactComponent };